import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import CloseButton from "../../../../components/commonComponents/Buttons/CloseButton";
import { Close, Preview } from "@mui/icons-material";
import PreviewSingleDashLayout from "./PreviewSingleDashLayout";
import { checkUserDetailsFromCookie } from "../../../../api_calls/userManagement";

const SingleSectionPreview = ({ showModal, closeModal, secType }) => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();

    const dashboardConfig = typeof currentStateData.workspace_section_selections !== "undefined" && typeof currentStateData.workspace_section_selections.embeddable_section_id !== "undefined" && typeof currentStateData.workspace_section_selections.section_name !== "undefined" ?
        {
            ...currentStateData.workspace_section_selections,
            tab_type: secType,
            filter_config: typeof currentStateData.workspace_filter_selections !== "undefined" && currentStateData.workspace_filter_selections.length !== 0 ? currentStateData.workspace_filter_selections.map(filterId => {
                const foundFilter = currentStateData.workspace_report_filters.find(
                    filterObj => filterObj.id === filterId
                );
                return foundFilter || "";
            }) : []
        } :
        "no-preview";

   

    return (
        <>
            <Dialog
                open={showModal}
                onClose={(e) => {
                    e.preventDefault();
                }}
                fullScreen={true}
            >
                <DialogContent>
                    {
                        dashboardConfig !== "no-preview" ?
                            <PreviewSingleDashLayout
                                newDashboardConfig={dashboardConfig}
                            /> : "No preview available"
                    }

                </DialogContent>
                <Box height={20} />
                <DialogActions>
                    <Stack direction={"row"} spacing={2}>
                        <CloseButton
                            onClick={(e) => {
                                e.preventDefault();
                                closeModal(false);
                            }}
                            label="Cancel"
                            icon={<Close />}
                        />
                    </Stack>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default SingleSectionPreview;
